import React from 'react'
import { connect } from 'react-redux'
import styles from './TRouteSegments.scss'
import { FullBleedList } from 'common/FullBleedList'
import { Distance, Duration, Elevation, Grade, Speed } from 'common/units'
import { featureTypes } from 'common/MapV2/featureTypes'
import { Msg, commonNouns, commonCTAs, commonMessages } from 'lib/localization'
import { TrackLocation } from 'data/records'
import { segmentMatchSelectors } from 'data/resources/segmentMatches'
import cx from 'classnames'
import _ from 'lodash'
import { FormattedMessage as T, injectIntl } from 'react-intl'

const SegmentMatch = ({ match, objectType, onMouseOver, onMouseOut, onClick }) => {
  const isTrip = objectType === 'trip'
  return <li
    className={cx(styles.segmentMatch, isTrip && styles.tripMatch)}
    onMouseOver={() => onMouseOver(match)}
    onClick={(e) => { !e.target.href && onClick(match) }} // don't zoom map if we're naving to segment
    onMouseOut={onMouseOut}>
    <a className={styles.title} href={`/segments/${match.segmentId}`}>{match.segmentTitle}</a>
    <div className={styles.grid}>
      <div className={cx(styles.column, styles.left)}>
        <Distance short value={match.distance} bigUnits />
        {isTrip && <span className={cx(match.personalRecord && styles.pr)}><Duration biggestUnits valueOnly value={match.duration} /></span>}
      </div>
      <div className={cx(styles.column, styles.middle)}>
        <span className={styles.eleGain}><Elevation short value={match.eleGain} /></span>
        {isTrip && <span className={cx(match.personalRecord && styles.pr)}><Speed short value={match.avgSpeed} bigUnits /></span>}
      </div>
      <div className={cx(styles.column, styles.right)}>
        <Grade short value={match.grade || 0} bigUnits />
        {isTrip && <span className={cx(match.personalRecord && styles.pr)}>{match.personalRecord && `#${match.rank}`}</span>}
      </div>
    </div>
  </li>
}

class _TRouteSegments extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      expanded: false
    }
  }

  toggleExpanded = () => this.setState({ expanded: !this.state.expanded })

  onMouseOver = (segmentMatch) => {
    const { onFeatureHovered } = this.props
    const highlightSlice = [
      TrackLocation({ left: segmentMatch.startIndex, pct: 0 }),
      TrackLocation({ left: segmentMatch.endIndex, pct: 0 })
    ]
    onFeatureHovered({
      type: featureTypes.SEGMENT_MATCH,
      data: { highlightSlice, segmentMatch }
    })
  }

  onClick = (segmentMatch) => {
    const { onFeatureSelected } = this.props
    const highlightSlice = [
      TrackLocation({ left: segmentMatch.startIndex, pct: 0 }),
      TrackLocation({ left: segmentMatch.endIndex, pct: 0 })
    ]
    onFeatureSelected({
      type: featureTypes.SEGMENT_MATCH,
      firstI: segmentMatch.startIndex,
      data: { highlightSlice, segmentMatch }
    })
  }

  onMouseOut = () => {
    const { onFeatureHovered } = this.props
    onFeatureHovered(null) // why does this inst-nerf the segment?
  }

  render () {
    const { segmentMatches, objectType, intl } = this.props
    const { expanded } = this.state

    if (!segmentMatches || segmentMatches.size === 0) {
      return null
    }

    const toShow = expanded
      ? segmentMatches.toIndexedSeq()
      : segmentMatches.toIndexedSeq().slice(0, 3)

    const segmentsStr = _.capitalize(intl.formatMessage(commonNouns.segments, { count: 0 }))

    return (
      <div className={styles.TRouteSegments}>
        <h2>{segmentsStr}</h2>
        {segmentMatches.size > 0 && <FullBleedList interactive>
          {toShow.map(sm => <SegmentMatch
            key={sm.id}
            match={sm}
            objectType={objectType}
            onMouseOver={this.onMouseOver}
            onMouseOut={this.onMouseOut}
            onClick={this.onClick} />)}
        </FullBleedList>}
        {segmentMatches.size > 3 && <div className={styles.expandlink}>
          <a onClick={() => this.toggleExpanded()}>
            {expanded
              ? <Msg m={commonMessages.collapse} values={{ list: segmentsStr }} />
              : <Msg m={commonMessages.showAll} values={{ list: segmentsStr }} />}
          </a>
        </div>}
        {segmentMatches.size === 0 && objectType === 'route' && <p>
          <T id='TRouteSegments.noSegments'
            defaultMessage='There are no segments for this {objectType}. Visit our {link} to learn how to create segments for a {objectType}.'
            values={{
              objectType,
              link: <a href='https://ridewithgps.com/help/segments' target='_blank'>
                <Msg m={commonCTAs.helpPage} />
              </a> }} />
        </p>}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  segmentMatches: segmentMatchSelectors.segmentsForParent(state, ownProps.objectType, ownProps.troute.id)
})

export const TRouteSegments = connect(
  mapStateToProps,
  null
)(injectIntl(_TRouteSegments))
